import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import ProductCard from '@/components/product/ProductCard';
import { brandsAPI, productsAPI } from '@/utils/api';

const Brands = () => {
  const [brands, setBrands] = useState([]);

  useEffect(() => {
    brandsAPI.getAll().then(setBrands);
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 lg:px-8 py-12">
      <div className="mb-10">
        <p className="text-xs tracking-[0.25em] uppercase text-[#D47A4A] font-semibold mb-2">Nuestras marcas</p>
        <h1 className="font-display font-bold text-4xl sm:text-5xl text-[#1C1917] tracking-tight">
          Marcas premium para tu mascota
        </h1>
        <p className="text-[#57534E] mt-3 max-w-2xl">
          Trabajamos con las marcas más reconocidas en nutrición animal, seleccionadas por su calidad, ingredientes y compromiso con la salud de tu mascota.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {brands.map((b) => (
          <Link
            key={b.id}
            to={`/marcas/${b.slug}`}
            data-testid={`brand-page-${b.slug}`}
            className="group bg-white rounded-2xl border border-[#E7E5E4] p-8 hover:border-[#2A5C43] hover:shadow-lg transition-all"
          >
            <div className="h-20 flex items-center justify-center mb-4">
              <p className="font-display font-bold text-2xl text-[#2A5C43] group-hover:text-[#D47A4A] transition-colors text-center">
                {b.name}
              </p>
            </div>
            <p className="text-sm text-[#57534E] leading-relaxed mb-4">{b.description}</p>
            <div className="flex items-center gap-1 text-sm text-[#2A5C43] font-medium group-hover:gap-2 transition-all">
              Ver productos <ArrowRight className="w-4 h-4" />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export const BrandDetail = () => {
  const { slug } = useParams();
  const [brand, setBrand] = useState(null);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    (async () => {
      const [b, p] = await Promise.all([
        brandsAPI.getBySlug(slug),
        productsAPI.getAll({ brand: slug })
      ]);
      setBrand(b);
      setProducts(p);
    })();
  }, [slug]);

  if (!brand) return <div className="max-w-7xl mx-auto px-4 py-12">Cargando...</div>;

  return (
    <div className="max-w-7xl mx-auto px-4 lg:px-8 py-12">
      <div className="mb-10">
        <p className="text-xs tracking-[0.25em] uppercase text-[#D47A4A] font-semibold mb-2">Marca</p>
        <h1 className="font-display font-bold text-4xl sm:text-5xl text-[#2A5C43] tracking-tight mb-3">
          {brand.name}
        </h1>
        <p className="text-[#57534E] max-w-3xl">{brand.description}</p>
        {brand.positioning && (
          <span className="inline-block mt-4 text-xs uppercase tracking-wider font-semibold px-3 py-1 rounded-full bg-[#2A5C43]/10 text-[#2A5C43]">
            {brand.positioning}
          </span>
        )}
      </div>

      {products.length > 0 ? (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6">
          {products.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      ) : (
        <div className="text-center py-16 bg-white rounded-2xl border border-[#E7E5E4]">
          <p className="text-[#57534E]">Próximamente disponible</p>
        </div>
      )}
    </div>
  );
};

export default Brands;
